import React from 'react';
import PropTypes from 'prop-types';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Collapse from '@material-ui/core/Collapse';
import { ArrowDropUp, ArrowDropDown } from '@material-ui/icons';
import SearchResultsList from './SearchResultsList';

// Open state lives in TargetSearch, which needs it to decide whether the
// suggestions list should dedupe against the candidates shown here.
const TopCandidates = ({
  entityType, candidates, onCandidateSelect, open, onToggle,
}) => {
  if (!candidates || candidates.length === 0) {
    return null;
  }

  const sortedCandidates = [...candidates].sort((a, b) => a.rank - b.rank);

  return (
    <React.Fragment>
      <div>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography color="inherit" variant="h6">
            {'Top Candidates'}
          </Typography>
          <IconButton
            color="inherit"
            style={{ height: 36, width: 36, marginRight: 6 }}
            onClick={onToggle}
          >
            {open ? <ArrowDropUp /> : <ArrowDropDown />}
          </IconButton>
        </div>
        <p
          style={{
            fontSize: 10,
            color: '#2196f3',
            fontWeight: '600',
            margin: 0,
          }}
        >
          Ranked by the matcher — pick one if it is the right match
        </p>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <SearchResultsList
            entityType={entityType}
            results={sortedCandidates}
            onResultSelect={onCandidateSelect}
            showRank
          />
        </Collapse>
      </div>
      <Divider style={{ margin: '20px 0' }} />
    </React.Fragment>
  );
};

TopCandidates.propTypes = {
  entityType: PropTypes.string.isRequired,
  candidates: PropTypes.instanceOf(Array),
  onCandidateSelect: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

TopCandidates.defaultProps = {
  candidates: [],
};

export default TopCandidates;
